import PanelItem from "./panel-item"

export default PanelItem